import { InternalContactsListAdmin } from '../../../../components/Contact/InternalContact';

export function TBMContactInternalContacts() {
  return <InternalContactsListAdmin />;
}
